import { matchRoutes, RouteConfig } from 'react-router-config'
import { Store } from 'redux'
import { UrlWithParsedQuery } from 'url'

import { IRootState } from '../../common/reducers'
import { ICommonLocation } from '../../common/utils/location/types'
import { IPageComponent } from '../../typings/pageComponent'

export default (
  store: Store<IRootState>,
  location: ICommonLocation,
  routes: RouteConfig[],
  apiUrlPrefix: string
) => {
  const branch = matchRoutes(routes, location.pathname)
  return branch.map(({ route, match }) => {
    const component = route.component as IPageComponent<any>
    return component && component.loadData
      ? component.loadData(store, location, apiUrlPrefix, match)
      : Promise.resolve({
          // resolve empty action
          type: 'noopAction'
        })
  })
}
